import { render, staticRenderFns } from "./coffee-quiz-question.vue?vue&type=template&id=50184245&scoped=true&"
import script from "./coffee-quiz-question.vue?vue&type=script&lang=js&"
export * from "./coffee-quiz-question.vue?vue&type=script&lang=js&"
import style0 from "./coffee-quiz-question.vue?vue&type=style&index=0&id=50184245&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50184245",
  null
  
)

export default component.exports